module.exports = __webpack_public_path__ + "img/ax220.2d5ec8b5.png";